unable to read source [project]/node_modules/.pnpm/is-emoji-supported@0.0.5/node_modules/is-emoji-supported/src/is-emoji-supported.ts